import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Barre de navigation principale, commune aux quatre écrans de premier niveau.
 * Elle était recopiée dans chacun d'eux : toute nouvelle entrée demandait quatre
 * modifications, avec le risque d'en oublier une.
 *
 * Les écrans de dossier gardent leur propre barre, contextuelle et différente.
 */
const ENTREES = [
  { cle: 'planning',  icone: '📅', libelle: 'Planning',  chemin: '/planning' },
  { cle: 'sav',       icone: '🔔', libelle: 'SAV Dispo', chemin: '/sav-dispo' },
  { cle: 'commande',  icone: '📦', libelle: 'Commande',  chemin: '/commande-ont' },
  { cle: 'bilan',     icone: '📊', libelle: 'Bilan',     chemin: '/bilan' },
  { cle: 'profil',    icone: '👤', libelle: 'Profil',    chemin: '/profile' },
];

export default function BarreNav({ actif }) {
  const navigate = useNavigate();
  return (
    <div className="bottomnav">
      {ENTREES.map(e => (
        <div
          key={e.cle}
          className={`nav-item${e.cle === actif ? ' active' : ''}`}
          onClick={e.cle === actif ? undefined : () => navigate(e.chemin)}
        >
          <span className="nav-icon">{e.icone}</span>{e.libelle}
        </div>
      ))}
    </div>
  );
}
